module.exports = __webpack_public_path__ + "media/images/front/team/sergio_luis_pons-0586143ecb2c60fc9cdbb993afb61336.jpg";